import { magic } from '@gig/magic-sdk';
import { FEATURE_QUERY_ENABLED, Feature } from '@gig/magic-messages';
import type { IUserProfile as ISdkUserProfile } from '@gig/magic-sdk/dist/adapter/users/user';

export interface IPhoneVerificationStatus {
    status: string;
}

export interface IUserProfileWithVerification extends ISdkUserProfile {
    phoneVerificationStatus?: IPhoneVerificationStatus;
}

/**
 * Checks if phone verification is required for the current user
 * @returns {Promise<boolean>} True if phone verification is required
 */
export async function isPhoneVerificationRequired(): Promise<boolean> {
    try {
        const isFeatureEnabled = await window.queryBus.query<string, boolean>(
            FEATURE_QUERY_ENABLED,
            Feature.PHONE_VERIFICATION_REQUIRED,
        );

        if (!isFeatureEnabled || !magic.session.isCreated()) {
            return false;
        }

        const userProfile =
            (await magic.methods.users.getUserProfile()) as IUserProfileWithVerification;

        return (
            userProfile.compliance.phoneVerificationStatus.status === 'Pending'
        );
    } catch (error) {
        console.error('Error checking phone verification status:', error);
        return false;
    }
}
